var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.1859,
    cy: 23.4686,
    r: 22.5316,
    fill: "url(#paint0_linear_1397_10026)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1397_10026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0462 30.3794C34.0462 30.9031 33.8382 31.4053 33.4679 31.7756C33.0976 32.1459 32.5954 32.354 32.0717 32.354H14.3007C13.777 32.354 13.2748 32.1459 12.9045 31.7756C12.5342 31.4053 12.3262 30.9031 12.3262 30.3794V19.5194C12.3262 18.9957 12.5342 18.4935 12.9045 18.1232C13.2748 17.7529 13.777 17.5448 14.3007 17.5448H18.2498L20.2244 14.583H26.148L28.1226 17.5448H32.0717C32.5954 17.5448 33.0976 17.7529 33.4679 18.1232C33.8382 18.4935 34.0462 18.9957 34.0462 19.5194V30.3794Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1864 28.4046C25.3674 28.4046 27.1355 26.6365 27.1355 24.4555C27.1355 22.2744 25.3674 20.5063 23.1864 20.5063C21.0054 20.5063 19.2373 22.2744 19.2373 24.4555C19.2373 26.6365 21.0054 28.4046 23.1864 28.4046Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1397_10026",
    x1: 23.1859,
    y1: 0.937012,
    x2: 33.8453,
    y2: 58.5921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1397_10026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.6946,
    height: 23.6946,
    fill: "white",
    transform: "translate(11.3389 11.6211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfileIcon);
export default __webpack_public_path__ + "static/media/EditProfileIcon.f4456e09b18a049b6b18175eaea80f57.svg";
export { ForwardRef as ReactComponent };